// Updated DistinctiveMarkForm.js
import React, { useState, useEffect } from 'react';

const MARK_TYPES = ['Tattoo', 'Scar', 'Birthmark', 'Other'];

function DistinctiveMarkForm({ onSubmit, initialData = {}, onCancel }) {
  const [formData, setFormData] = useState({
    mark_type: 'Tattoo',
    location: '',
    description: '',
  });

  const isEditing = !!initialData.id;

  useEffect(() => {
    if (isEditing) {
      setFormData({
        mark_type: initialData.mark_type || 'Other',
        location: initialData.location || '',
        description: initialData.description || '',
      });
    }
  }, [initialData, isEditing]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg">
        <div className="card"> {/* Add card class for styling */}
          <form onSubmit={handleSubmit}>
            <h2 className="text-xl font-bold text-slate-800 mb-6">{isEditing ? 'Edit' : 'Add'} Distinctive Mark</h2>
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">Type</label>
                <select 
                  name="mark_type" 
                  value={formData.mark_type} 
                  onChange={handleChange}
                  className="w-full" // This will pick up your App.css styling
                >
                  {MARK_TYPES.map(type => <option key={type} value={type}>{type}</option>)}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">Location on Body</label>
                <input 
                  type="text" 
                  name="location" 
                  placeholder="e.g., Left forearm" 
                  value={formData.location} 
                  onChange={handleChange}
                  className="w-full" // This will pick up your App.css styling
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">Description</label>
                <textarea 
                  name="description" 
                  value={formData.description} 
                  onChange={handleChange} 
                  rows="4" 
                  required
                  className="w-full" // This will pick up your App.css styling
                />
              </div>
            </div>
            <div className="flex justify-end gap-4 pt-6 mt-6 border-t border-slate-200">
              <button 
                type="button" 
                onClick={onCancel} 
                className="bg-slate-200 text-slate-700 hover:bg-slate-300 font-bold py-2 px-6 rounded-lg transition-colors"
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="bg-yellow-500 text-white hover:bg-yellow-600 font-bold py-2 px-6 rounded-lg transition-colors"
              >
                Save Mark
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default DistinctiveMarkForm;